import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
} from 'react-router';

import { LazyRoute } from '@client/components/LazyRoute';
import { ProtectedRoute } from '@client/components/ProtectedRoute';
import { AuthProvider } from '@client/context/AuthContext';
import {
  HomePage,
  AuthPage,
  DashboardPage,
  FeaturesPage,
  FeatureEditPage,
  SubscriptionsPage,
  SubscriptionEditPage,
  TenantsPage,
  TenantEditPage,
  AdminMarketplacePage,
  AdminMarketplaceFeaturesPage,
  CreditsPage,
  RevenuePage,
  EntitlementsPage,
  NotFoundPage,
  WarningPage,
  MainLayout,
} from '@client/routes/lazy-routes';
import { ERoutePaths } from '@client/types/router.type';

export const router = createBrowserRouter(
  createRoutesFromElements(
    <Route
      errorElement={
        <LazyRoute>
          <WarningPage />
        </LazyRoute>
      }
    >
      <Route
        index
        element={
          <LazyRoute>
            <HomePage />
          </LazyRoute>
        }
      />
      <Route
        element={
          <AuthProvider>
            <LazyRoute>
              <MainLayout />
            </LazyRoute>
          </AuthProvider>
        }
      >
        <Route
          path={ERoutePaths.LOGIN}
          element={
            <LazyRoute>
              <AuthPage />
            </LazyRoute>
          }
        />
        <Route
          path={ERoutePaths.PROFILE}
          element={
            <LazyRoute>
              <ProtectedRoute>
                <>Profile</>
              </ProtectedRoute>
            </LazyRoute>
          }
        />
        <Route
          path={ERoutePaths.DASHBOARD}
          element={
            <LazyRoute>
              <ProtectedRoute>
                <DashboardPage />
              </ProtectedRoute>
            </LazyRoute>
          }
        />
        <Route
          path={ERoutePaths.TENANTS}
          element={
            <LazyRoute>
              <ProtectedRoute>
                <TenantsPage />
              </ProtectedRoute>
            </LazyRoute>
          }
        />
        <Route
          path={ERoutePaths.TENANT_EDIT}
          element={
            <LazyRoute>
              <ProtectedRoute>
                <TenantEditPage />
              </ProtectedRoute>
            </LazyRoute>
          }
        />
        <Route
          path={ERoutePaths.SUBSCRIPTIONS}
          element={
            <LazyRoute>
              <ProtectedRoute>
                <SubscriptionsPage />
              </ProtectedRoute>
            </LazyRoute>
          }
        />
        <Route
          path={ERoutePaths.SUBSCRIPTION_EDIT}
          element={
            <LazyRoute>
              <ProtectedRoute>
                <SubscriptionEditPage />
              </ProtectedRoute>
            </LazyRoute>
          }
        />
        <Route
          path={ERoutePaths.FEATURES}
          element={
            <LazyRoute>
              <ProtectedRoute>
                <FeaturesPage />
              </ProtectedRoute>
            </LazyRoute>
          }
        />
        <Route
          path={ERoutePaths.FEATURE_EDIT}
          element={
            <LazyRoute>
              <ProtectedRoute>
                <FeatureEditPage />
              </ProtectedRoute>
            </LazyRoute>
          }
        />
        <Route
          path={ERoutePaths.ADMIN_MARKETPLACE}
          element={
            <LazyRoute>
              <ProtectedRoute>
                <AdminMarketplacePage />
              </ProtectedRoute>
            </LazyRoute>
          }
        />
        <Route
          path={ERoutePaths.ADMIN_MARKETPLACE_FEATURES}
          element={
            <LazyRoute>
              <ProtectedRoute>
                <AdminMarketplaceFeaturesPage />
              </ProtectedRoute>
            </LazyRoute>
          }
        />
        <Route
          path={ERoutePaths.CREDITS}
          element={
            <LazyRoute>
              <ProtectedRoute>
                <CreditsPage />
              </ProtectedRoute>
            </LazyRoute>
          }
        />
        <Route
          path={ERoutePaths.REVENUE}
          element={
            <LazyRoute>
              <ProtectedRoute>
                <RevenuePage />
              </ProtectedRoute>
            </LazyRoute>
          }
        />
        <Route
          path={ERoutePaths.ENTITLEMENTS}
          element={
            <LazyRoute>
              <ProtectedRoute>
                <EntitlementsPage />
              </ProtectedRoute>
            </LazyRoute>
          }
        />
        <Route
          path={ERoutePaths.NOT_FOUND}
          element={
            <LazyRoute>
              <NotFoundPage />
            </LazyRoute>
          }
        />
      </Route>
    </Route>,
  ),
);
